import { OpenInNewRounded } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { IRIS_URL } from '../../../../environment';

function IrisVesselLinkButton() {
  const handleClick = (e: React.FormEvent) => {
    e.preventDefault();
    window.open(IRIS_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        marginBottom: '1rem',
      }}
    >
      <Button
        variant="contained"
        color="primary"
        startIcon={<OpenInNewRounded />}
        aria-label="Iris vessel link button"
        data-testid="iris-vessel-link-button"
        onClick={handleClick}
      >
        Download Fleet from Iris
      </Button>
    </Box>
  );
}

export default IrisVesselLinkButton;
